import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'form-fields-array',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-fields-array {
        display: flex;
        flex: 1;
        flex-wrap: wrap;

        &--title {
          font-weight: 500;
          color: var(--p-text-muted-color);
          padding: 5px;
        }
        &--content {
          display: flex;
          flex: 1;
          min-width: 100%;
          flex-wrap: wrap;
          gap: 10px;
        }
        .form-fields-array--row {
          display: flex;
          // overflow: hidden;
          flex: 1;
          min-width: 100%;
          gap: 10px;
        }
        .form-fields-array--row-content {
          display: flex;
          flex: 1;
        }

        .form-fields-array--row-buttons {
          display: flex;
          align-content: center;
          flex-wrap: wrap;
        }
        .form-fields-array--add-container {
          display: flex;
          flex: 1;
          justify-content: flex-end;
        }
      }
    `,
  ],
  template: `
    <div *ngIf="props.label" class="form-fields-array--title">
      {{ props['translate'] ? (props.label || '' | translate) : props.label }}
    </div>
    <div class="form-fields-array--content">
      <div
        *ngFor="let field of field.fieldGroup; let i = index"
        class="form-fields-array--row"
      >
        <div class="form-fields-array--row-content">
          <formly-field class="col" [field]="field"></formly-field>
        </div>
        <div class="form-fields-array--row-buttons">
          <p-button
            icon="pi pi-trash"
            aria-label="{{
              'formsCommon.default.removeEntryIconTooltip' | translate
            }}"
            (click)="remove(i)"
          />
        </div>
      </div>
      <div class="form-fields-array--add-container">
        <p-button
          *ngIf="
            field.props['addEntryButtonLabel'] !== undefined &&
            field.props['addEntryButtonLabel'] !== ''
          "
          icon="pi pi-plus"
          aria-label="{{ 'formsCommon.default.addIconTooltip' | translate }}"
          [label]="
            field.props['translate']
              ? (field.props['addEntryButtonLabel'] | translate)
              : field.props['addEntryButtonLabel']
          "
          (click)="add()"
        />
        <p-button
          *ngIf="
            !(
              field.props['addEntryButtonLabel'] !== undefined &&
              field.props['addEntryButtonLabel'] !== ''
            )
          "
          icon="pi pi-plus"
          aria-label="{{
            'formsCommon.default.addEntryIconTooltip' | translate
          }}"
          [label]="'formsCommon.default.addEntryButtonLabel' | translate"
          (click)="add()"
        />
      </div>
    </div>
  `,
})
export class FormFieldsArrayType extends FieldArrayType {
  @HostBinding('class')
  readonly cssClass = 'form-fields-array';
}
